import { render, staticRenderFns } from "./VideoStudy.vue?vue&type=template&id=02266c7b&scoped=true&"
import script from "./VideoStudy.vue?vue&type=script&lang=js&"
export * from "./VideoStudy.vue?vue&type=script&lang=js&"
import style0 from "./VideoStudy.vue?vue&type=style&index=0&id=02266c7b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02266c7b",
  null
  
)

export default component.exports